<div style="border: solid 1px gray; padding: 15px; margin-top: 15px">
  <h2>Child Component</h2>
  <button (click)="clickButton()">Click Me</button>
</div>
